import { usePrerollDurationWatcher } from '../../feature-player/hooks/skin/use-preroll-duration';

import { useFilmCurrentStream } from './use-film-current-stream';

export const useFilmPrerollDurationWatcher = (contentId: string) =>
    usePrerollDurationWatcher(useFilmCurrentStream(contentId));
